import getBlockById from './apiHelpers/getBlockById';

// we can swap out the implementation of this for the faster / cleaner check
export const getIsFirstInteraction = (topics, currentInteraction): boolean => {
  const firstInteraction = getBlockById(topics[0]?.children[0]?.id)
    ?.children?.[0] as any;

  // console.log(firstInteraction.id, currentInteraction);

  if (currentInteraction) {
    return currentInteraction === firstInteraction?.id;
  }

  return false;
};
